import { InternalAxiosRequestConfig } from 'axios'
import { EnumApiUser } from '@xt/client/api/user'
import singleToken from '@xt/client/experimental/request/token'
import singleServiceTime from '@xt/client/experimental/server-time'

export const authInterceptors = {
  success: async (options: InternalAxiosRequestConfig) => {
    let token = singleToken.getToken()

    if (options.headers['Authorization']) {
      return options
    }

    if (token?.access_token) {
      const minutes = singleToken.expirationTime.diff(singleServiceTime.serviceDate.valueOf(), 'minutes')
      if (minutes < 2 && !isWhiteListUrl(options.url!)) {
        console.warn(`${options.url}即将触发refreshToken`)
        token = (await singleToken.refreshToken(options)) ?? token
      }

      options.headers['Authorization'] = `${token.token_type} ${token.access_token}`
    }

    return options
  },
  fail: () => {}
}

function isWhiteListUrl(url: string) {
  const whiteList = [EnumApiUser.Login, EnumApiUser.ShortcutDeviceBind, EnumApiUser.AppletBind, EnumApiUser.SaveDeviceInfo] as string[]
  const startUrlWhiteList = ['/date', '/mocks']
  return whiteList.some(_url => url.includes(_url) || startUrlWhiteList.some(_url => url.startsWith(_url)))
}
